import { PxApi } from "@/api/PxApi";
import { CheckListReq, CheckListRes, SyainCsvReq } from "@/types/Px";

export class PxService {

  /**
  * 勤怠CSVダウンロードをします
  * @param params
  * @returns
  */
  public async downloadKintaiCSV(start:string, end:string): Promise<any> {
    const api = new PxApi();
    try {
      return await api.downloadKintaiCSV(start, end);
    } catch (e) {
      return null;
    }
  }

  /**
  * CSVをダウンロードします
  * @param params
  * @returns
  */
  public async downloadSyainCSV(userId: number, koyouKeiyakuId: number | null) {
    const api = new PxApi();
    const req: SyainCsvReq = {
      userId,
      koyouKeiyakuId
    };
    try {
      return await api.downloadSyainCSV(req);
    } catch (e) {
      return null;
    }
  }

  // 勤務承認の確定状況をを取得
  public async getKinmuStatusForPx(req: CheckListReq):Promise<CheckListRes> {
    const api = new PxApi();
    try {
      return await api.getKinmuStatusForPx(req);
    } catch (e: any) {
      console.log(e)
      throw e;
    }
  }
}
